module.exports = __webpack_public_path__ + "img/ic_argentina.f645e40a.svg";